'use strict';

const noop = () => { };
const noopReturn = (v) => v;

exports.noop = noop;
exports.noopReturn = noopReturn;
